var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_19236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C9.1055 5.5 6.75 7.87183 6.75 10.7879C6.75 14.9313 11.5065 19.2095 11.7089 19.3892C11.7923 19.4632 11.8962 19.5 12 19.5C12.1038 19.5 12.2077 19.4633 12.2911 19.3898C12.4935 19.2095 17.25 14.9313 17.25 10.7879C17.25 7.87183 14.8945 5.5 12 5.5ZM12 13.6667C10.3917 13.6667 9.08333 12.3582 9.08333 10.75C9.08333 9.14175 10.3917 7.83333 12 7.83333C13.6082 7.83333 14.9167 9.14175 14.9167 10.75C14.9167 12.3582 13.6082 13.6667 12 13.6667Z",
    fill: "#2E1834"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_19236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5ad86185dc44a262dc6985b8fd10a18f.svg";
export { ForwardRef as ReactComponent };